<template>
  <div class="examine-list">
    <el-table
      :data="examineList"
      border
      style="width: 100%"
      tooltip-effect="dark"
      class="common-edit-button"
    >
      <el-table-column
        prop="teacherNumber"
        width="150px"
        :show-overflow-tooltip="true"
        label="申请人工号"
      >
      </el-table-column>
      <el-table-column
        prop="teacherName"
        width="150px"
        :show-overflow-tooltip="true"
        label="申请人姓名"
      >
      </el-table-column>
      <!-- <el-table-column width="100px" label="审核类型">
        <template slot-scope="scope">
          {{ getLeaveType(scope.row.status) }}
        </template>
      </el-table-column> -->
      <el-table-column width="220px" label="发布时间" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.createTime }}
        </template>
      </el-table-column>
      <el-table-column label="敏感词" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.sensitiveWords | newSensitiveWords }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :width="examineStatus == 0 ? '220px' : '150px'"
        fixed="right"
      >
        <template slot-scope="scope">
          <div class="operate">
            <!-- 修改 -->
            <el-button type="primary" size="small" @click="showDetail(scope.row.id)"
              >详情
            </el-button>
            <!-- 同意 -->
            <el-button
              v-show="scope.row.status == 0"
              type="success"
              size="small"
              @click="updateStatus(scope.row.id, 1)"
              v-hasPermi="'sc:newscheck:edit'"
              >同意
            </el-button>
            <!-- 拒绝 -->
            <el-button
              v-show="scope.row.status == 0"
              type="danger"
              size="small"
              @click="updateStatus(scope.row.id, 2)"
              v-hasPermi="'sc:newscheck:edit'"
            >
              拒绝
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    examineList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    examineStatus: {
      type: Number,
      require: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    updateStatus(id, status) {
      // console.log(id,status);
      // 修改敏感字审核状态 status:1同意 2拒绝
      this.put(this.$url.updateExamineRecordStatus, {
        id,
        status,
      })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$emit("updateStatus", id);
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log("审判失败==>", err);
          // this.$message.error("操作失败，请稍后重试");
        });
    },
    // 显示详情
    showDetail(id) {
      // console.log(id)
      this.$eventBus.$emit("showDetail", id);
    },
  },
  filters: {
    // 敏感字去重
    newSensitiveWords(e) {
      // 转数组然后去重
      e = e.split(",");
      let words = e.filter((item, index) => e.indexOf(item) == index);
      // 去重完重新转回字符串
      e = words.join(",");
      return e;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./examine-list.scss";
</style>
